import noop from 'lodash/fp/noop';

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const AppLink = ({ name, url, handleOnClick = noop, children }) => {
    if (/^https?:\/\//.test(url)) {
        return <a data-component='appLink'
            role='menuitem'
            className='app-link'
            key={`link-icon-${name}`}
            href={url}>
            {children}
        </a>;
    }
    return <Link data-component='appLink'
        role='menuitem'
        className='app-link'
        key={`link-icon-${name}`}
        onClick={(event) => handleOnClick(event)}
        to={url}>
        {children}
    </Link>;
};

export const AppNavigatorItem = ({ handleOnClick, name, route, tileIcon }) => {
    return (
        <div className='ApplicationNavigatorItem'>
            <AppLink name={name} url={route} handleOnClick={handleOnClick}>
                <div className='icon-wrap' style={{ backgroundImage: `url(${tileIcon})` }}/>
                <div className='caption'>
                    {name}
                </div>
            </AppLink>
        </div>
    );
};

export default AppNavigatorItem;

AppNavigatorItem.defaultProps = {
    handleOnClick: noop,
};

AppNavigatorItem.propTypes = {
    handleOnClick: PropTypes.func,
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]).isRequired,
    route: PropTypes.string.isRequired,
    tileIcon: PropTypes.string,
};
